import WelcomeFreeTrialForm from './WelcomeFreeTrialForm';

export default WelcomeFreeTrialForm;
